import DocumentRequirement from '../../DocumentRequirement/DocumentRequirement';
import styles from './BankStatements.module.css';
import messages from './BankStatements.messages';
import { FormattedMessage } from 'react-intl';

const ManualUpload = () => {
    return (
        <DocumentRequirement documentType="bank statement">
            <>
                <h4 className={styles.manualTitle}>
                    <FormattedMessage {...messages.manualUploadTitle} />
                </h4>

                <ul>
                    <li>
                        <FormattedMessage {...messages.firstBullet} />
                    </li>
                    <li>
                        <FormattedMessage {...messages.secondBullet} />
                    </li>
                </ul>
            </>
        </DocumentRequirement>
    );
};

// eslint-disable-next-line import/no-default-export
export default ManualUpload;
